import Typography from "@mui/material/Typography"

import { BannerArrow, BannerElipse1, BannerElipse2 } from "../../iconRef/bannerIcons";
import styles from "./manualBanner.module.css";
import { Manual } from "./utils/homepageJson.types";

const ManualBanner = ({ manual }: { manual: Manual }) => {
  const customColor = manual.background_colour;

  return (
    <div className={styles.wrapper} id={`manual-banner-${manual.id}`} style={{ backgroundColor: `${customColor}` }}>
      <div>
        <img
          alt="banner-recipe"
          className={styles.banner_recipe_img}
          src={manual.image}
        />
      </div>
      <div className={styles.recipe_outline_small}><BannerElipse2 /></div>
      <div className={styles.recipe_outline_large}><BannerElipse1 /></div>
      <div className={styles.banner_text_wrapper}>
        <Typography className={styles.banner_subtitle_text} sx={{ color: `${customColor}` }}>{manual.subtitle}</Typography>
        <div><Typography className={styles.banner_title_text}>{manual.title}</Typography></div>
        <div className={styles.button_text_container}><Typography className={styles.button_text}>{manual.button_text}</Typography><BannerArrow /></div>
      </div>
    </div>
  )
}

export default ManualBanner